<template>
  <div class="UserInfo">
    <div class="aui-user-header">
        <div class="aui-user-content">
          <div class="aui-user-fex">
            <div class="aui-user-fex-head" style="padding-left:4px">
              <div class="aui-user-fex-photo" >
                <img :src="userAvatar" alt="">
              </div>
              <div class="aui-user-fex-title" style="margin-left:16px;">
                <h2 style="line-height:12px;font-size:24px;">{{userName}}({{userNo}})</h2>
                <h2 style="line-height:16px;font-size:14px;height:21px"> {{departmentName}}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
     <!--<van-row style="margin-top:20px;">
        <van-grid :column-num="2" :gutter="10">
          <van-grid-item icon="column" text="Mes标准版"  @click="changeApp('mes')" :class="[curApp =='mes'?'select':'']"/>
          <van-grid-item icon="todo-list" text="Wms标准版"  @click="changeApp('wms')" :class="[curApp =='wms'?'select':'']"/>
        </van-grid>
      </van-row>-->
      <van-row style="padding:20px">
        <van-button round   size="large" type="default" @click="loginOut" style="height:40px;" >重新登录</van-button>
    </van-row>
  </div>
</template>
  
  <script>
import Vue from 'vue'
import '../../css/home.css'
import store from '../../store/index'
import { getUserDetail } from '../../api/users'
import { router }  from '../../router'

export default {
    components: {

    },
    computed: {
    },
    data() {
      return {
        userNo:'',
        userName:'',
        userAvatar:'',
        departmentName:'',
        curApp:''
      };
    },
    mounted(){
      this.userNo = store.state.authorize.user.userNo;
      this.userName = store.state.authorize.user.userName;
      this.userAvatar = store.state.authorize.userAvatar;
      this.curApp = store.state.app.curApp;

      getUserDetail(this.userNo).then(res=>{
        this.departmentName = res.data.departmentName;
      });
    },
    methods: {
      loginOut(){
        store.commit('authorize/SET_TOKEN',null)
        store.commit('authorize/SET_USER', null)
        store.commit('authorize/SET_USERAVATAR', null)
        store.commit('app/SET_COMPANYNAME', null)

        var url = store.state.app.sysConfig.useWechatApi?'/wechatLogin':'/customLogin';
        router.push(url);
      },
      changeApp(appName){
        store.commit('app/SET_CURAPP', appName)
        setTimeout(() => {
          window.location.reload();
        }, 500); 
      }
    }
  };
  </script>
  
  <style lang="less">
  .van-doc-demo-block__title {
  margin: 0;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}

.select{
  color:indianred
}
  </style>
  